export const DEFAULT_BRAND_CODE = "ciilock";

export const BRANDS = [
  { code: "ciilock", name: "CiiLOCK" },
  { code: "durabal", name: "Durabal" },
  { code: "siigmatic", name: "SiiGMATIC" },
];

const DASHBOARD_DEFAULT_MIN_RELEVANCE_BRANDS = new Set(["ciilock", "durabal", "siigmatic"]);

export function normalizeBrandCode(v) {
  const code = String(v || "").trim().toLowerCase();
  return BRANDS.some((b) => b.code === code) ? code : DEFAULT_BRAND_CODE;
}

export function getSelectedBrandCode() {
  return normalizeBrandCode(localStorage.getItem("selectedBrandCode"));
}

export function setSelectedBrandCode(code) {
  const normalized = normalizeBrandCode(code);
  localStorage.setItem("selectedBrandCode", normalized);
  window.dispatchEvent(new Event("brandUpdated"));
}

export function shouldDefaultDashboardMinRelevanceToFifty(code) {
  return DASHBOARD_DEFAULT_MIN_RELEVANCE_BRANDS.has(normalizeBrandCode(code));
}
